import e, { useMemo as x, useState as B, useRef as ne, useEffect as h } from "react";
import { Link as _ } from "../Link/Link.js";
import { LogoOLX as oe } from "../LogoOLX/LogoOLX.js";
import { Button as le } from "../Button/Button.js";
import { Navbar as ie } from "../Navbar/Navbar.js";
import { VisuallyHidden as I } from "../VisuallyHidden/VisuallyHidden.js";
import { ArrowLeft as me, Menu as se, Briefcase as ce, Grid as de, MessageCircle as pe, Bell as ue } from "@olxbr/ds-icons";
import { OverflowMenu as he } from "./components/OverflowMenu/OverflowMenu.js";
import { Profile as _e } from "./components/Profile/Profile.js";
import { SkipLinks as fe } from "./components/SkipLinks/SkipLinks.js";
import { IconButton as H } from "./components/IconButton/IconButton.js";
import "../Avatar/Avatar.js";
import { useLoadNotificationsBadge as be } from "./services/useLoadNotificationsBadge.js";
import { usePageActive as ge } from "../Navbar/usePageActive.js";
import { sendClickEvent as i } from "./utils/sendClickEvent.js";
import { getABTestVariant as Ee, isOnControlVariant as R } from "../../helpers/ab.js";
import { headerDefaultProps as A } from "./props.js";
import { useGetLoginInfo as xe } from "./services/useGetLoginInfo.js";
import { useNavigation as Ne } from "./services/useNavigation.js";
import { OnboardingTooltip as T } from "./components/OnboardingTooltip/OnboardingTooltip.js";
import { useIsMobileResize as ve } from "../../hooks/useIsMobileResize.js";
import { getOnboardingExtraData as we, sendOnboardingEvent as j } from "./utils/onboardingTracking.js";
import { getOnboardingCookie as ye, shouldShowOnboarding as ke, disableOnboardingCookie as Oe, incrementOnboardingCount as Ce } from "./utils/onboardingCookie.js";
import { addMouseflowTag as Pe } from "../../helpers/mouseflowHandler.js";
var Me = Object.defineProperty,
  Se = Object.defineProperties,
  Ie = Object.getOwnPropertyDescriptors,
  V = Object.getOwnPropertySymbols,
  Ae = Object.prototype.hasOwnProperty,
  Le = Object.prototype.propertyIsEnumerable,
  W = (r, a, t) => a in r ? Me(r, a, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[a] = t,
  z = (r, a) => {
    for (var t in a || (a = {})) Ae.call(a, t) && W(r, t, a[t]);
    if (V) for (var t of V(a)) Le.call(a, t) && W(r, t, a[t]);
    return r;
  },
  De = (r, a) => Se(r, Ie(a));
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const F = _ref => {
  let {
    teamKey: r,
    fixed: a = A.fixed,
    searchInput: t,
    mainId: U = A.mainId,
    footerId: G = A.footerId,
    goBack: m,
    hideMainNotificationOnABTest: K,
    hasNavbar: n,
    newMaxWidth: N,
    enableExternalData: X,
    externalData: Z,
    notFooter: $,
    onUserChange: v,
    enableOnboarding: q,
    isLocalABTest: L
  } = _ref;
  const w = x(() => Ee("menu-pro"), []),
    J = new URLSearchParams(typeof window != "undefined" ? document.location.search : ""),
    c = xe({
      teamKey: r,
      enableExternalData: X,
      externalData: Z,
      disableUsernameTruncation: !R(w)
    }),
    {
      isAutosPro: d,
      isLogged: f,
      userName: Q
    } = c,
    b = d && !R(w),
    s = x(() => ye(), []),
    y = b && w === "onboard",
    k = !!(q && y && ke(s)),
    [p, O] = B(k),
    [g, D, Y] = be(),
    [o, u] = B(!1),
    E = ne(null),
    {
      pageActive: ee,
      handleToggleAccount: ae
    } = ge(),
    l = x(() => ({
      login: f
    }), [f]),
    te = () => {
      ae(), u(S => !S);
    };
  Ne({
    headerWrapperRef: E,
    openSubMenu: o
  });
  const re = J.has("hide-burger-menu");
  h(() => {
    typeof v == "function" && v(c);
  }, [c, v]);
  const C = ve();
  h(() => {
    k && O(!0);
  }, [s, k]), h(() => {
    o && (O(!1), y && Oe(s));
  }, [o, s, y]);
  const P = x(() => we(d, f, !!n, b), [d, f, n, b]);
  h(() => {
    p && (Ce(s), j("impression", P));
  }, [p, P, s]);
  const M = () => {
    j("close", P), O(!1);
  };
  return h(() => {
    d && Pe("autos-pro");
  }, [d]), e.createElement("header", {
    id: "header",
    "data-ds-component": "DS-Header",
    className: "olx-header",
    "data-open": o,
    "data-fixed": a,
    "data-newmaxwidth": N,
    ref: E
  }, e.createElement("nav", {
    className: "olx-header__main-menu",
    "aria-label": "Menu principal",
    "data-newmaxwidth": N
  }, e.createElement("div", {
    className: "olx-header__primary-menu",
    "data-newmaxwidth": N
  }, e.createElement("div", {
    className: "olx-header__column-left"
  }, e.createElement(fe, {
    headerWrapperRef: E,
    mainId: U,
    footerId: G,
    notFooter: $
  }), n && !!m && e.createElement(H, z({
    className: "olx-header__back-button",
    onClick: () => {
      typeof m == "function" && m(), i("back", "main_menu", l);
    },
    tag: typeof m == "string" ? "a" : "button"
  }, typeof m == "string" && {
    href: m
  }), e.createElement(me, null), e.createElement(I, null, "Voltar")), !n && !re && e.createElement(H, {
    onClick: () => {
      u(S => !S);
    },
    "aria-controls": "ds-overflow-menu",
    "aria-expanded": o,
    className: "olx-header__burger-menu",
    "data-header-keyboard-navigation": "true",
    "data-header-burger-menu": "true"
  }, e.createElement(T, {
    open: C && p,
    closeCallback: M,
    className: "olx-header__onboarding-tooltip--burger",
    placement: "top-start"
  }, e.createElement("span", {
    className: "olx-header__logo-wrapper"
  }, e.createElement(se, null)), e.createElement(I, null, "Menu"))), e.createElement(_, {
    href: "https://www.olx.com.br",
    dsParentName: "Header",
    onClick: () => i("logo", "main_menu", l),
    "data-header-keyboard-navigation": "true"
  }, e.createElement(I, null, "P\xE1gina inicial"), e.createElement("span", {
    className: "olx-header__olx-container"
  }, e.createElement(oe, {
    dsParentName: "Header"
  }))), t && !L && e.createElement("div", {
    "data-hasnavbar": !!n,
    className: "olx-header__search"
  }, t)), e.createElement("div", {
    className: "olx-header__column-right"
  }, e.createElement("ul", {
    className: "olx-header__items"
  }, e.createElement("li", {
    className: "olx-header__item",
    "data-professional": "true"
  }, e.createElement(_, {
    dsParentName: "Header",
    href: "https://planoprofissional.olx.com.br/",
    "data-header-keyboard-navigation": "true",
    variant: "grey",
    size: "small",
    onClick: () => i("my_plan", "main_menu", l),
    className: "olx-header__link"
  }, e.createElement("span", {
    className: "olx-header__logo-wrapper"
  }, e.createElement(ce, null)), e.createElement("span", {
    className: "olx-header__label"
  }, "Plano Profissional"))), e.createElement("li", {
    className: "olx-header__item",
    "data-myads": "true"
  }, e.createElement(_, {
    dsParentName: "Header",
    href: "https://conta.olx.com.br/anuncios",
    "data-header-keyboard-navigation": "true",
    variant: "grey",
    size: "small",
    onClick: () => i("my_ads", "main_menu", l),
    className: "olx-header__link"
  }, e.createElement("span", {
    className: "olx-header__logo-wrapper"
  }, e.createElement(de, null)), e.createElement("span", {
    className: "olx-header__label"
  }, "Meus An\xFAncios"))), e.createElement("li", {
    className: "olx-header__item",
    "data-hasnavbar": n
  }, e.createElement(_, {
    dsParentName: "Header",
    href: "https://conta.olx.com.br/chats",
    "data-header-keyboard-navigation": "true",
    variant: "grey",
    size: "small",
    onClick: () => i("chat", "main_menu", De(z({}, l), {
      chatNotifications: g
    })),
    className: "olx-header__link"
  }, e.createElement("span", {
    className: "olx-header__logo-wrapper"
  }, e.createElement("span", {
    className: "olx-header__notification-wrapper",
    "data-counter": g > 9 ? "+9" : g
  }, e.createElement(pe, null))), e.createElement("span", {
    "data-variant": "chat",
    className: "olx-header__label"
  }, "Chat"))), e.createElement("li", {
    className: "olx-header__item",
    "data-hidenotification": n && K
  }, e.createElement(_, {
    dsParentName: "Header",
    href: "https://conta.olx.com.br/notificacoes",
    "data-header-keyboard-navigation": "true",
    variant: "grey",
    size: "small",
    onClick: () => i("notification", "main_menu", l),
    className: "olx-header__link"
  }, e.createElement("span", {
    className: "olx-header__logo-wrapper"
  }, e.createElement("span", {
    className: "olx-header__notification-wrapper",
    "data-counter": D > 9 ? "+9" : D
  }, e.createElement(ue, null))), e.createElement("span", {
    "data-variant": "notification",
    className: "olx-header__label"
  }, "Notifica\xE7\xF5es"))), e.createElement("li", {
    className: "olx-header__item"
  }, e.createElement(T, {
    open: !C && p,
    closeCallback: M,
    placement: "bottom"
  }, e.createElement(_e, {
    "data-variant": "profile",
    onLogin: Y,
    accountInfo: c,
    openSubMenu: o,
    setOpenSubMenu: u
  }, e.createElement(he, {
    headerWrapperRef: E,
    openSubMenu: o,
    setOpenSubMenu: u,
    accountInfo: c,
    hasNavbar: n,
    fixed: a,
    showProMenu: b
  })))), e.createElement("li", {
    "data-variant": "anunciar",
    className: "olx-header__item",
    "data-hasnavbar": n
  }, e.createElement(le, {
    dsParentName: "Header",
    tag: "a",
    "data-header-keyboard-navigation": "true",
    className: "olx-header__desapegar-button",
    href: "https://www2.olx.com.br/desapega",
    onFocus: () => u(!1),
    onClick: () => i("ad_insert", "main_menu", l)
  }, "Anunciar"))))), !!t && !L && !n && e.createElement("div", {
    className: "olx-header__search-fluid"
  }, t), n && e.createElement(ie, {
    pageActive: ee,
    onClickAccount: te,
    isLogged: !!Q,
    chatNotification: g,
    onboardingOpen: C && p,
    onboardingCloseCallback: M
  })));
};
F.displayName = "Header";
export { F as Header };